import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import { BROCHURE_LIST } from '../../helpers/brochures';

export default function BrochureMenu({
  onDownload,
  menuId = 'cs-brochure-menu',
  resetKey,
}) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    setOpen(false);
  }, [resetKey]);

  useEffect(() => {
    if (!open) return undefined;

    const closeOnOutside = (event) => {
      if (!menuRef.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('pointerdown', closeOnOutside);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOnOutside);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);

  return (
    <div
      className={`cs_brochure_menu${open ? ' is-open' : ''}`}
      ref={menuRef}
    >
      <button
        type="button"
        className="cs_header_demo_btn"
        aria-expanded={open}
        aria-haspopup="true"
        aria-controls={menuId}
        onClick={() => setOpen((current) => !current)}
      >
        Download Brochure
        <Icon icon="lucide:chevron-down" width={16} height={16} aria-hidden="true" />
      </button>
      <ul className="cs_brochure_dropdown" id={menuId} role="menu">
        {BROCHURE_LIST.map((brochure) => (
          <li key={brochure.id} role="none">
            <a
              href={brochure.href}
              download={brochure.fileName}
              role="menuitem"
              onClick={() => {
                setOpen(false);
                onDownload?.();
              }}
            >
              <Icon icon="lucide:file-text" width={16} height={16} aria-hidden="true" />
              <span>
                <strong>{brochure.title}</strong>
                <small>{brochure.subtitle}</small>
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
